<template>
  <a-card :bordered="false">
    <div class='s_flex_bian m-b-60'>
      <div class="card ">
        <div class="card_main">
          <div class="card_items s_bf4f">
            <div class='card_item s_wsn'>
              <h6 style="font-weight:400">{{info.balance || 0}}</h6>
              <span>账户余额（元）</span>
            </div>
            <div class='card_item  s_wsn'>
              <h6 style="font-weight:400">{{info.deduct || 0}}</h6>
              <span>总支付金额（元）</span>
            </div>
            <div class='card_item s_wsn'>
              <h6 style="font-weight:400">{{info.passage || 0}}</h6>
              <span>在途金额（元）</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-form ref='form' :model='search' class="m-b-25" :initialValues="search" :onFinish='initData' layout='inline'>
         <a-form-item label="名称">
           <a-input v-model:value="search.title"></a-input>
      </a-form-item>
      <a-form-item label="">
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
      </a-form-item>
      <!-- <a-form-item label="类型">
        <a-select style="width: 120px" v-model:value="search.order_source">
          <a-select-option value="">
            全部
          </a-select-option>
          <a-select-option :value="1">
            平台充值
          </a-select-option>
          <a-select-option :value="2">
            平台扣款
          </a-select-option>
          <a-select-option :value="3">
            代发红包
          </a-select-option>
          <a-select-option :value="4">
            累计金额红包
          </a-select-option>
          <a-select-option :value="5">
            累计金额红包发放
          </a-select-option>
        </a-select>
      </a-form-item> -->
      <a-form-item>
        <a-button type="primary" @click='initData'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table bordered  :pagination='false' class='m-b-20' :data-source="detail.data" :columns="columns" :loading='loading' >
       <template v-slot:action="{ record }">
        <a v-has:balanceAccountExport="()=>exportDetail(record)" href="javascript:;" v-if="record.is_have_detail==1">导出明细</a>
       </template>
    </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
  </a-card>
</template>
<script>
import { onMounted, ref } from "vue";
import {bill_index,balance_info,exporTbalance} from '@/api/system'
import { message } from 'ant-design-vue';
import { iscode } from '../../../utils/app';
export default {
  name: "orderType",
  setup() {
    const dataSource = ref([]);
    const columns = [
      {
        title: "订单号",
        dataIndex: "bill_no",
      },
       {
        title: "名称",
        dataIndex: "title",
      },
      {
        title: "时间",
        dataIndex: "create_time",
      },
      // {
      //   title: "类型",
      //   dataIndex: "type_text",
      // },
      {
        title: "金额（元）",
        dataIndex: "number",
      },
       {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    const time = ref([]);
    const search = ref({
      start_time: "",
      end_time: "",
      title: "",
      limit:10,
      page:1
    });
    const total=ref(0)
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    };
    const detail = ref([]);
    const loading = ref(false);
    const info=ref({})
    const getInfo=async()=>{
      let result = await balance_info(search.value).then((res) => res.data).catch((error) => error);
      if (iscode(result)) {
        info.value = result.data;
      } else {
        message.error(result.msg);
      }
    }
    const initData = async () => {
      loading.value = true;
      let result = await bill_index(search.value).then((res) => res.data).catch((error) => error);
      if (iscode(result)) {
        detail.value = result.data;
        total.value=result.data.total;
        loading.value = false;
      } else {
        message.error(result.msg);
      }
    };
    onMounted(()=>{
      getInfo()
      initData();
    })
    const exportDetail=async (data)=>{
      const hide = message.loading('导出中...', 0);
      let result=await  exporTbalance({day:data.day,type:data.type}).then(res=>res.data).catch(error=>error)
      setTimeout(hide);
      if(iscode(result)){
        window.open(result.data.file_url)
      }else{
        message.error(result.msg);
      }
    }
    const onSearch=()=>{
      search.value.page=1
      initData()
    }
    
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    return {
      dataSource,
      columns,
      onChange,
      time,
      search,
      info,
      exportDetail,
      initData,
      loading,
      onSearch,
      detail,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      total
    };
  },
};
</script>
<style lang="less" scoped>
.card {
  height: 140px;
  border-radius: 8px;
  &:first-child {
    flex: 1;
  }
  &:nth-child(2) {
    flex: 2;
  }
  .card_main {
    height: 100%;
    .border-right {
      border-right: 1px solid #d0d9e3;
    }
    .card_items {
      border-radius: 5px;
      display: flex;
      flex: 1;
      align-items: center;
      height: 100%;
      .card_item {
        padding: 0 20px;
        height: 80%;
        flex: 1;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        h6 {
          font-size: 30px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 600;
          color: #333;
          line-height: 51px;
        }
        span {
          font-size: 16px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #333;
          line-height: 24px;
        }
      }
    }
  }
}
</style>